import { render } from "./NotificationTalkArea.vue?vue&type=template&id=d9284610&scoped=true"
import script from "./NotificationTalkArea.vue?vue&type=script&lang=js"
export * from "./NotificationTalkArea.vue?vue&type=script&lang=js"

import "./NotificationTalkArea.vue?vue&type=style&index=0&id=d9284610&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1189531127/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9284610"]])

export default __exports__